
import { createContext, useState } from 'react';

const UserContext = createContext({ //for autoComplete
    user: null,
    setUserData: (user) => {},

    isSubscribed:null,
    setIsSubscribed:(val)=>{},

    isSettingInfo:null,
    setIsSettingInfo:(val)=>{},

    unreadAnswers:null,
    setUnreadAnswers: ()=>{},

    selectedPath:'',
    setSelectedPath:()=>{},
    
});


export function UserContextProvider(props) { //providing context for fav and updating fav
    const [user, setUser] = useState({});
    const [isSettingInfo, setIsSettingInfo] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(true);
    const [unreadAnswers, setUnreadAnswers] = useState(0);
    const [selectedPath, setSelectedPath] = useState('');


    // return a new array to setuserfav    favmeetup+userfav
    function handleUserData(user){setUser(user)}
    function handleIsSettingInfo(val){setIsSettingInfo(val)}
    function handleIsSubscribed(val){setIsSubscribed(val)}
    function handleUnreadAnswers(val){setUnreadAnswers(val)}
    function handleSelectedPath(val){setSelectedPath(val)}



    const context = {
        user: user,
        setUserData: handleUserData,
        
        isSettingInfo:isSettingInfo,
        setIsSettingInfo:handleIsSettingInfo,

        isSubscribed:isSubscribed,
        setIsSubscribed:handleIsSubscribed,

        unreadAnswers:unreadAnswers,
        setUnreadAnswers:handleUnreadAnswers,

        selectedPath:selectedPath,
        setSelectedPath:handleSelectedPath,
    }


    //whatever content we wrap the conponent bellow with it will get the latest 'context' update  
    return <UserContext.Provider value={context}>
           {props.children}
           </UserContext.Provider>;
}

export default UserContext; //favcontext itself  not the  component